import { useEffect, useState } from "react";
import CustomNavItem from "../../../Components/Components/CustomNavItem";
import ProductDocumentation from "../../../Components/ProductPage/ProductDocumentation";
import LoadingSpinner from "../../../Components/Components/LoadingSpinner";
import useAIDescription from "../../../Hooks/useAIDescription";
import { useParams } from "../../../Providers/ParamsProvider";

const ProductDetails = ({ product }) => {
    const [tabs, setTabs] = useState(['Dokumentacja', 'Opis produktu'])
    const [activeTab, setActiveTab] = useState('Dokumentacja')
    const [aiDescObj, setAiDescObj] = useState({ desc: '', status: -1 })
    const { handleGetAIDescription, handleGetAIDescriptionFromDatabase } = useAIDescription()
    const { aiDescriptionIsActive } = useParams()

    useEffect(() => {
        if (product.productInformations && product.productInformations.length > 0) {
            setTabs(prev => {
                if (prev.includes('Cechy produktu')) {
                    return prev
                }
                return ['Cechy produktu', ...prev]
            })
            setActiveTab('Cechy produktu')
        }
    }, [product])

    useEffect(() => {
        if (product?.index) {
            if (aiDescriptionIsActive) {
                handleProductAiDescription()
            }
            else { //pobieramy opis ferrodo
                setAiDescObj({ desc: product.description, status: 0 })
            }
        }
    }, [product.index])

    useEffect(() => {
        let isMounted = true // Flaga chroniąca przed wywołaniem na odmontowanym komponencie

        const handleTryGetDescryptionFromDatabase = async () => {
            let attempts = 0
            const maxAttempts = 3
            let found = false
            while (attempts < maxAttempts) {
                await new Promise(resolve => setTimeout(resolve, 5000)) // Czekaj 10 sekund

                if (!isMounted) {
                    return
                }

                attempts++
                try {
                    let dbRes = await handleGetAIDescriptionFromDatabase(product.index)
                    if (dbRes && typeof dbRes === 'string' && dbRes.trim() !== '') {
                        setAiDescObj({ desc: dbRes, status: 0 })
                        found = true
                        break
                    }
                } catch (error) {
                    console.error("Błąd podczas sprawdzania bazy danych:", error)
                }
            }

            // Jeśli po 5 próbach dalej nie ma opisu
            if (!found && isMounted) {
                setAiDescObj({ desc: '', status: 2 })
            }
        }

        if (aiDescObj.status == 1 && aiDescriptionIsActive) {
            handleTryGetDescryptionFromDatabase(isMounted)
        }

        return () => {
            isMounted = false
        }
    }, [aiDescObj.status, product])

    const handleProductAiDescription = async () => {
        if (product.aiDescStatus != 0) {
            let res = await handleGetAIDescription(product)
            setAiDescObj({ desc: res.desc, status: res.status })
        }
        else {
            setAiDescObj({ desc: product.aiDesc, status: 0 })
        }
    }

    const generateContent = () => {
        switch (activeTab) {
            case 'Opis produktu':
                return <DetailsTab
                    aiDescObj={aiDescObj}
                />
            case 'Cechy produktu':
                return <ProductInformation
                    product={product}
                />
            case 'Dokumentacja':
                return <ProductDocumentation
                    index={product.index}
                />
        }
    }

    return (
        <div style={{ height: '70vh' }}>
            <div className="mb-3">
                <CustomNavItem
                    items={tabs}
                    defaultItem={tabs[0]}
                    onClick={(item) => setActiveTab(item)}
                    isFullWidth={false}
                />
            </div>
            <div className="main-container-holder" style={{ width: '100%', height: '65vh', marginTop: '-10px' }}>
                {generateContent()}
            </div>
        </div>
    )
}

const DetailsTab = ({ aiDescObj }) => {
    if (aiDescObj.status == 0) {
        return (
            <iframe
                srcDoc={aiDescObj.desc}
                title="Opis produktu"
                style={{ width: '100%', height: '100%' }}
            />
        )
    }
    else if (aiDescObj.status == 2) {
        return <p className="error-text-color">Brak opisu</p>
    }
    return <LoadingSpinner loadingText="Wczytywanie opisu..." />
}

const ProductInformation = ({ product }) => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        {product.productInformations && product.productInformations.slice(0, Math.ceil(product.productInformations.length / 2)).map((item, index) => (
                            <div className="row">
                                <div className="col-6 text-start">
                                    <p>{item.name}:</p>
                                </div>
                                <div className="col-6 text-end">
                                    <p><strong>{item.value}</strong></p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-6">
                        {product.productInformations && product.productInformations.slice(Math.ceil(product.productInformations.length / 2)).map((item, index) => (
                            <div className="row">
                                <div className="col-6 text-start">
                                    <p>{item.name}:</p>
                                </div>
                                <div className="col-6 text-end">
                                    <p><strong>{item.value}</strong></p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetails